export const itemMaterialTypes = {
  ADDITION: "Adição",
  ADDITIVE: "Aditivo",
  CEMENT: "Cimento",
  GRAVEL: "Brita",
  SAND: "Areia",
  WATER: "Água",
};

export const sensorMaterialTypes = {
  ADDITIVE: "Aditivo",
  CEMENT: "Cimento",
  AGGREGATE: "Agregado",
  SILO: "Silo",
  WATER: "Água",
};

export const actuatorTypes = {
  pulse: "Pulsar",
  hold: "Segurar",
  keep: "Manter",
};

export const arrowPositionTypes = {
  BOTTOM: "Base",
  LEFT: "Esquerda",
  RIGHT: "Direita",
  TOP: "Topo",
};

export const plantLocationTypes = {
  ACTUATOR: "Atuadores",
  AGGREGATES: "Agregados",
  APP: "QR Code",
  BOOST: "TopGo",
  GENERAL: "Insumos + Atuadores",
  MAINTENANCE: "Painel Virtual",
  PAUSE: "Pausa",
  STATUS: "Status",
  STOP: "Cancelar",
  TRUCK: "Caminhão"
};
